import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue'), meta: { guest: true } },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '数据概览' } },
      { path: 'courses', name: 'CourseList', component: () => import('../views/CourseManage.vue'), meta: { title: '课程管理' } },
      { path: 'courses/edit/:id?', name: 'CourseEdit', component: () => import('../views/course/Edit.vue'), meta: { title: '课程编辑' } },
      { path: 'categories', name: 'CategoryList', component: () => import('../views/QuestionCategoryManage.vue'), meta: { title: '题库分类' } },
      { path: 'questions', name: 'QuestionList', component: () => import('../views/question/List.vue'), meta: { title: '题目管理' } },
      { path: 'categories/:categoryId/questions', name: 'CategoryQuestionList', component: () => import('../views/question/List.vue'), meta: { title: '分类题目' } },
      { path: 'questions/edit/:id?', name: 'QuestionEdit', component: () => import('../views/question/Edit.vue'), meta: { title: '题目编辑' } },
      { path: 'topic-categories', name: 'TopicCategoryList', component: () => import('../views/topic/CategoryList.vue'), meta: { title: '专题分类' } },
      { path: 'topic-questions', name: 'TopicQuestionList', component: () => import('../views/topic/QuestionList.vue'), meta: { title: '专题题库' } },
      { path: 'orders', name: 'OrderList', component: () => import('../views/order/List.vue'), meta: { title: '订单管理' } },
      { path: 'users', name: 'UserList', component: () => import('../views/UserManage.vue'), meta: { title: '用户管理' } },
      { path: 'users/:id', name: 'UserDetail', component: () => import('../views/user/Detail.vue'), meta: { title: '用户详情' } },
      { path: 'login-logs', name: 'LoginLogs', component: () => import('../views/LoginLogs.vue'), meta: { title: '登录日志' } },
      { path: 'admin-users', name: 'AdminUserList', component: () => import('../views/AdminUsers.vue'), meta: { title: '管理员管理' } }
    ]
  }
];

const router = new VueRouter({ mode: 'history', base: process.env.BASE_URL, routes });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token');
  if (to.meta.guest) {
    if (token) next({ path: '/' });
    else next();
  } else if (!token) {
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
